import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  notificationContainer: {
    display: "flex",
    backgroundColor: colors.whiteBlue,
    border: `1px solid ${colors.babyBlue}`,
    borderRadius: "8px",
    padding: "16px",
    textAlign: "start",    
    margin: "8px 24px"
  },
  icon: {
    marginRight: "12px",
    "& path": {
      stroke: colors.primary600Blue
    }
  },
  title: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    color: colors.darkBlue,
    padding: "3px 0px" 
  },
  description: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.darkBlue,
    paddingBottom: "12px" 
  },
  button: {
    "& span": {
        marginRight: "8px"
    }
  }
}));

export default styles;
